export const AGENT_OPERATION_PERMISSION_FIELDS = Object.freeze({
  add: "add",
  edit: "edit",
  freeze: "freeze",
  delete: "delete",
});

export const AGENT_OPERATION_PERMISSION_OPTIONS = Object.freeze([
  {
    field: AGENT_OPERATION_PERMISSION_FIELDS.add,
    labelKey: "common.add",
  },
  {
    field: AGENT_OPERATION_PERMISSION_FIELDS.edit,
    labelKey: "common.editor",
  },
  {
    field: AGENT_OPERATION_PERMISSION_FIELDS.freeze,
    labelKey: "lanV4.Freeze",
  },
  {
    field: AGENT_OPERATION_PERMISSION_FIELDS.delete,
    labelKey: "lanV4.Delete",
  },
]);

export const DEFAULT_ROLE_OPERATION_PERMISSIONS = Object.freeze({
  add: 0,
  edit: 0,
  freeze: 0,
  delete: 0,
});

export const HISTORY_ROLE_OPERATION_PERMISSIONS = Object.freeze({
  add: 1,
  edit: 1,
  freeze: 1,
  delete: 1,
});

const PERMISSION_FIELD_LIST = Object.keys(AGENT_OPERATION_PERMISSION_FIELDS).map(
  (key) => AGENT_OPERATION_PERMISSION_FIELDS[key]
);

function toFormPermissionNumber(value) {
  return value === true || Number(value) === 1 ? 1 : 0;
}

function toApiPermissionNumber(value) {
  return value === 0 || value === 1 ? value : 0;
}

function hasOwn(source, field) {
  return Object.prototype.hasOwnProperty.call(source || {}, field);
}

function isPermissionMap(source) {
  return source && typeof source === "object" && !Array.isArray(source);
}

function copyPermissions(permissions) {
  return PERMISSION_FIELD_LIST.reduce((result, field) => {
    result[field] = permissions[field];
    return result;
  }, {});
}

function getHistoryPermissionDefaults(roleType) {
  return shouldShowRoleOperationPermissions(roleType)
    ? HISTORY_ROLE_OPERATION_PERMISSIONS
    : DEFAULT_ROLE_OPERATION_PERMISSIONS;
}

function normalizeApiPermissionMap(permission) {
  return PERMISSION_FIELD_LIST.reduce((result, field) => {
    result[field] = hasOwn(permission, field)
      ? toApiPermissionNumber(permission[field])
      : DEFAULT_ROLE_OPERATION_PERMISSIONS[field];
    return result;
  }, {});
}

function normalizeApiOperationPermissions(source) {
  const permission = source && source.permission;
  if (permission === null || permission === undefined) {
    return copyPermissions(getHistoryPermissionDefaults(source && source.roleType));
  }
  if (!isPermissionMap(permission)) {
    return copyPermissions(DEFAULT_ROLE_OPERATION_PERMISSIONS);
  }
  return normalizeApiPermissionMap(permission);
}

export function normalizeRoleOperationPermissions(source) {
  return normalizeApiOperationPermissions(source);
}

export function normalizeCurrentAgentOperationPermissions(source) {
  return normalizeApiOperationPermissions(source);
}

function normalizeFormOperationPermissions(source) {
  const permission = source && source.permission ? source.permission : source;
  return PERMISSION_FIELD_LIST.reduce((result, field) => {
    result[field] = toFormPermissionNumber(permission && permission[field]);
    return result;
  }, {});
}

export function getRoleOperationPermissionParams(form) {
  return {
    permission: normalizeFormOperationPermissions(form),
  };
}

export function hasAgentOperationPermission(permissions, field) {
  return toApiPermissionNumber(permissions && permissions[field]) === 1;
}

export function shouldShowRoleOperationPermissions(roleType) {
  return Number(roleType) === 1 || Number(roleType) === 2;
}

export default {
  AGENT_OPERATION_PERMISSION_FIELDS,
  AGENT_OPERATION_PERMISSION_OPTIONS,
  DEFAULT_ROLE_OPERATION_PERMISSIONS,
  HISTORY_ROLE_OPERATION_PERMISSIONS,
  getRoleOperationPermissionParams,
  hasAgentOperationPermission,
  normalizeCurrentAgentOperationPermissions,
  normalizeRoleOperationPermissions,
  shouldShowRoleOperationPermissions,
};
